








































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import UtenteGeneralData from './UtenteGeneralData.vue';
import UtenteRoles from './UtenteRoles.vue';
import UtenteHeadquarters from './UtenteHeadquarters.vue';
import UtenteCallCenter from './UtenteCallCenter.vue';
import UtenteFattorino from './UtenteFattorino.vue';
import AttorePersonalData from '../../attori/attore/AttorePersonalData.vue';
import { CrudService } from '@/data/services/crud.service';
import { User, UserType } from '@/data/models/user.model';
import store, { State } from '@/store';
import { aclChecker } from '@/data/utils/acl';
import { Actor } from '@/data/models/actor.model';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';

@Component({
	components: {
		UtenteGeneralData,
		UtenteRoles,
		UtenteHeadquarters,
		UtenteCallCenter,
		UtenteFattorino,
		AttorePersonalData,
		ValidationObserver,
		ValidationProvider,
	},
})
export default class UtenteDetail extends Vue {
	@Prop() utenteid?: number | string;
	@Prop({ default: true }) editable!: boolean;
	@Prop() hqid?: number | string;

	@Inject('CrudService') utenteCrudService!: CrudService<User>;
	@Inject('CrudService') actorCrudService!: CrudService<Actor>;

	utente!: User;
	actor!: Actor;
	
	admin: boolean = false;

	loading: boolean = false;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.utente = new User();
		this.actor = new Actor();
		this.admin = aclChecker('role.admin');
	}

	@Watch('utente')
	onValueChange(value: any) {
		if (value.id) {
			this.loadActor();
		}
	}

	loadUtente(id: number) {
		this.loading = true;
		this.utenteCrudService
			.getEntity(User, 'user', id)
			.then((result) => {
				this.utente = result;
				if(this.utente.isTypeFattorino) {
					this.loadActor();
				}
			})
			.catch((error) => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger',
				});
			}).finally(() => this.loading = false);
	}

	onActorUpdate(actor: Actor) {
		this.actor = actor;
	}

	loadActor() {
		const search = new Search('actor');
		search.addSimpleFilter('uid', this.utente.id);
		this.actorCrudService.searchEntities(Actor, 'actor', search, new Page(1)).then(actor => {
			if(actor) {
				this.actor = actor[0];
			}
		});
	}

	created() {
		if (this.utenteid) {
			this.loadUtente(+this.utenteid);
		} else {
			this.utente = new User();
			this.utente.utype = this.$route.meta['utype'];
			this.utente.creaactor = this.utente.utype === UserType.FATTORINO;
			this.utente.hqid = !this.utente.isTypeAdmin ? this.state.headquarter!.id : undefined; 
		}
	}
}
